
import React, { useEffect, useState, useRef } from "react";
import "./NX5_MonitorVitalData.scss";
import { ProgressBarCustom } from "../ProgressBarCustom/ProgressBarCustom";
import ChartCustom from "../Chart/Chart";
import { Line } from "react-chartjs-2";
import ApexChart from "../../components/Chart/ApexChart";
import whiteUpArrow from "../../common/icons/svg/white-up-arrow.svg";
import whiteDownArrow from "../../common/icons/svg/white-down-arrow.svg";
import { GRAPH_TYPE, VITAL_ECG, MORE_GRAPH_OPTIONS_VITAL, RESP_OBJ, PLETH_OBJ, ETCO2_OBJ, IBP1_OBJ, IBP2_OBJ, MONITOR_PARAMETER } from "../../common/constant/common-constants";
import moment from "moment";
import LChart from "../Chart/LCReact";
import monitorOfflineIcon from "../../common/icons/svg/patient-monitor-offline.svg"
import pacemakerImage from "../../common/images/Pacemaker.png";
import alarmMuteImage from "../../common/images/alarm_mute.png";

import { handleOutsideClick } from "../../common/utils/CommonUtils";

const dataArray = new Array(5000);

for (let i = 0; i < dataArray.length; i++) {


   
    dataArray[i] = 1;
}


export function NX5_MonitorVitalData(props) {


    const TIME_RANGE_IN_MILLISECONDS = 6;
    const [barPercen, setBarPercen] = useState(0);
    const [dataObj, setDataObj] = useState(dataArray);
    const [secondEcgData, setSecondEcgData] = useState(dataArray);
    const [plethObj, setPlethObj] = useState(dataArray);
    const [respObj, setRespObj] = useState(dataArray);
    const [etco2Obj, setEtco2Obj] = useState(dataArray);
    const [ibp1Obj, setIbp1Obj] = useState(dataArray);
    const [ibp2Obj, setIbp2Obj] = useState(dataArray);
    const [vitalECG, setVitalECG] = useState(VITAL_ECG.I);
    const [moreVitalECG, setMoreVitalECG] = useState(false);
    const [secondMoreVitalECG, setSecondMoreVitalECG] = useState(false);
    const [vitalGraphName, setVitalGraphName] = useState(MORE_GRAPH_OPTIONS_VITAL.MONITOR[0]);
    const [secondvitalGraphName, setSecondVitalGraphName] = useState(MORE_GRAPH_OPTIONS_VITAL.MONITOR[1]);
    const [plethTime, setPlethTime] = useState(null);
    const [bedId, setBedId] = useState(null);
    const [lastPushedPlethTime, setLastPushedPlethTime] = useState(null);
    const [lastPushedRespTime, setLastPushedRespTime] = useState(null);
    const [lastPushedEcg1Time, setLastPushedEcg1Time] = useState(new Date());
    const [lastPushedEcg2Time, setLastPushedEcg2Time] = useState(null);
    const [lastPushedEtco2Time, setLastPushedEtco2Time] = useState(null);
    const [lastPushedIbp1Time, setLastPushedIbp1Time] = useState(null);
    const [lastPushedIbp2Time, setLastPushedIbp2Time] = useState(null);


    const options = (stepSize, plottedPoints, index) => {
        
        return (
            {
                animation: {
                    duration: 0, // Set the animation duration to 0 to disable it
                },
                scales: {
                    x: {
                        type: 'linear',
                        position: 'bottom',
                        ticks: {
                            display: false,

                        },

                    },
                    y: {
                        ticks: {
                            display: false, // Display tick marks along the y-axis
                            stepSize: stepSize,
                        },
                        type: 'linear',
                        display: true,
                        scaleLabel: {
                            display: false,
                            labelString: 'Value'
                        },
                        min: null,
                        max: null, //Math.ceil((Math.max(maxY) + Math.max(maxY) * 25 / 100)/index) || 1,
                    }
                },
                plugins: {
                    legend: {
                        display: false, // Hide the legend
                    },
                    tooltip: {
                        enabled: false, // Disable tooltips
                    },
                    annotation: {
                        annotations: {
                            line: {
                                drawTime: 'afterDatasetsDraw',
                                type: 'line',
                                scaleID: 'y',
                                value: 0,
                                borderWidth: 2,
                            },
                        }
                    }
                },
                elements: {
                    line: {
                        tension: 0 // Disable bezier curves to get straight lines
                    }
                },
                maintainAspectRatio: false, // Set to false to allow direct control over width and height
                responsive: true,
            }
        )
    }

    useEffect(() => {

        if (bedId !== props.bedId) {


            setDataObj(dataArray);
            setSecondEcgData(dataArray);
            setPlethObj(dataArray);
            setRespObj(dataArray);
            setEtco2Obj(dataArray);
            setIbp1Obj(dataArray);
            setIbp2Obj(dataArray);

            setBedId(props.bedId);
        }

    }, [props.bedId])

  

    const handleSecondVitalECGSelect = (option) => {
        // setVitalECG(option)
        setSecondVitalGraphName(option);
        setSecondMoreVitalECG(false);
    }

  
    const handleSecondMoreVitalECG = (event) => {
        if (!secondMoreVitalECG) {
            handleOutsideClick(event, 'vital-ecg-graph-2', setSecondMoreVitalECG);
        }
    }



   // console.log(props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_DIFF]?.value)

   if (props?.monitorHeartBeatData?.isConnected) {
        return (
            <div className="vitals-container">
                <div className="graph-data">
                    <div className="all-graph">

                        <div className="HR-graph">
                            <div className="HR-top-bar">
                                <div className="HR-graph-num">II</div>
                                {/* <div className="HR-ratio">x4</div> */}
                            </div>
                            <div className="ecg-graph-1">
                                {dataObj &&
                                    <Line
                                        data={{
                                            labels: Array.from({ length: 3000 }, (_, i) => i + 1),
                                            datasets: [{
                                                label: 'ECG Graph I',
                                                // data: dataObj.map(dataPoint => dataPoint.y / 100),
                                                data: props.monitorEcgWaveFormData?.waveform[MORE_GRAPH_OPTIONS_VITAL.MONITOR[1].id],
                                                borderColor: '#00E233',
                                                fill: false,
                                                pointRadius: 0,
                                                tension: 0.1,
                                                borderWidth: 2
                                            }]
                                        }}
                                        options={options(10)}
                                    />
                                }


                            </div>
                            {/* <div className="HR-bottom-bar">
                                <div className="HR-Dia">Dia</div>
                                <div className="HR-mv">1mv</div>
                                <div className="HR-notch">Notch off</div>
                            </div> */}
                        </div>
                        <div className="PR-graph">
                            <div className="select-vital-ecg-container" onClick={(event) => handleSecondMoreVitalECG(event)}>
                                <div className="selected-vital-ecg-name">
                                    {secondvitalGraphName.label}
                                </div>
                                {secondMoreVitalECG && <img className="arrow-img" src={whiteUpArrow} />}
                                {!secondMoreVitalECG && <img className="arrow-img" src={whiteDownArrow} />}
                                {secondMoreVitalECG && <div className="vital-graph-options" id="vital-ecg-graph-2">
                                    {
                                        MORE_GRAPH_OPTIONS_VITAL.MONITOR.map((option) => {
                                            return (
                                                <div className={option.name === secondvitalGraphName.name ? `common-vital-ecg vital-ecg-active` : `common-vital-ecg`}
                                                    onClick={(event) => handleSecondVitalECGSelect(option)} key={option.name}>{option.label}</div>
                                            )
                                        })
                                    }
                                </div>}

                                {/* <div className="ratio">x4</div> */}
                            </div>
                            <div className="ecg-graph-2">
                                {secondEcgData &&
                                    <Line
                                        data={{
                                            labels: Array.from({ length: 3000 }, (_, i) => i + 1),
                                            datasets: [{
                                                label: 'ECG Graph II',
                                                data: props.monitorEcgWaveFormData?.waveform[secondvitalGraphName.id],
                                                borderColor: '#00E233',
                                                fill: false,
                                                pointRadius: 0,
                                                tension: 0.1,
                                                borderWidth: 2
                                            }]
                                        }}
                                        options={options(10)}
                                    />
                                }
                            </div>
                        </div>
                        <div className="RR-graph">
                            <div className="resp-graph">

                                <Line
                                    data={{
                                        labels: Array.from({ length: 3000 }, (_, i) => i + 1),
                                        datasets: [{
                                            label: 'RR',
                                            data: props.monitorRespWaveFormData?.waveform?.[RESP_OBJ.id],
                                            borderColor: '#FCC331',
                                            fill: false,
                                            pointRadius: 0,
                                            tension: 0.1,
                                            borderWidth: 2
                                        }]
                                    }}
                                    options={options(1)}
                                />

                            </div>
                        </div>
                        <div className="SPO2-graph">
                            <div className="pleth-graph">


                                <Line
                                    data={{
                                        labels: Array.from({ length: 1600 }, (_, i) => i + 1),
                                        datasets: [{
                                            label: 'Pleth',
                                            data: props.monitorPlethWaveFormData?.waveform?.[PLETH_OBJ.id],
                                            borderColor: '#3ADAE5',
                                            fill: false,
                                            pointRadius: 0,
                                            tension: 0.1,
                                            borderWidth: 2
                                        }]
                                    }}
                                    options={options(1)}
                                />



                            </div>
                        </div>









                    </div>
                    <div className="all-values">
                        <div className="HR">
                            <div className="left">

                                <div className="top-bar">

                                    <div className="label">HR</div>

                                    <img className="pacemaker" src={pacemakerImage} alt="Pacemaker" />



                                    {
                                        props.vitalData_ECG?.[MONITOR_PARAMETER.HR]?.alarm_enable === false
                                            ? <img className="alarm-mute" src={alarmMuteImage} alt="Alarm-Mute" />
                                            : null
                                    }



                                </div>

                                <div className="unit">(beats/min)</div>




                            </div>
                            <div className="middle">

                                <div className="value">
                                    {
                                       

                                        props.vitalData_ECG?.[MONITOR_PARAMETER.HR]?.value ?? "-"

                                    }
                                </div>




                            </div>
                            <div className="right">

                                <div className="limits">
                                    <span className="high">{props.vitalData_ECG?.[MONITOR_PARAMETER.HR]?.alarm_limit[1] ?? "-"}


                                    </span>
                                    <span className="low">

                                        {props.vitalData_ECG?.[MONITOR_PARAMETER.HR]?.alarm_limit[0] ?? "-"}
                                    </span>
                                </div>


                            </div>


                        </div>
                        <div className="PR">
                            <div className="left">

                                <div className="info">

                                    <div className="top-bar">

                                        <div className="label">PR</div>



                                        {
                                            props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2_PULSE_RATE]?.alarm_enable === false
                                                ? <img className="alarm-mute" src={alarmMuteImage} alt="Alarm-Mute" />
                                                : null
                                        }



                                    </div>

                                    <div className="unit">(beats/min)</div>

                                </div>

                                <div className="source">SOURCE:SPO2</div>




                            </div>
                            <div className="middle">

                                <div className="value">
                                    {

                                     
                                        props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2_PULSE_RATE]?.value ?? "-"
                                    }
                                </div>




                            </div>
                            <div className="right">

                                <div className="limits">
                                    <span className="high">{props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2_PULSE_RATE]?.alarm_limit[1] ?? "-"}</span>
                                    <span className="low">{props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2_PULSE_RATE]?.alarm_limit[0] ?? "-"}</span>
                                </div>


                            </div>



                        </div>
                        <div className="RR">

                            <div className="left">

                                <div className="info">

                                    <div className="top-bar">

                                        <div className="label">RR</div>

                                        {
                                            props.vitalData_ECG?.[MONITOR_PARAMETER.RR]?.alarm_enable === false
                                                ? <img className="alarm-mute" src={alarmMuteImage} alt="Alarm-Mute" />
                                                : null
                                        }







                                    </div>

                                    <div className="unit">(b/min)</div>

                                </div>

                                <div className="source">SOURCE:ECG</div>




                            </div>
                            <div className="middle">

                                <div className="value">
                                    {
                                        
                                        props.vitalData_ECG?.[MONITOR_PARAMETER.RR]?.value ?? "-"

                                    }
                                </div>




                            </div>
                            <div className="right">

                                <div className="limits">
                                    <span className="high">{props.vitalData_ECG?.[MONITOR_PARAMETER.RR]?.alarm_limit[1] ?? "-"}</span>
                                    <span className="low">{props.vitalData_ECG?.[MONITOR_PARAMETER.RR]?.alarm_limit[0] ?? "-"}</span>
                                </div>


                            </div>




                        </div>
                        <div className="SPO2">

                            <div className="left">

                                <div className="info">

                                    <div className="top-bar">

                                        <div className="label">SPO2</div>
                                        {
                                            props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2]?.alarm_enable === false
                                                ? <img className="alarm-mute" src={alarmMuteImage} alt="Alarm-Mute" />
                                                : null
                                        }







                                    </div>

                                    <div className="unit">(%)</div>

                                </div>


                                <div className="source">

                                    <div className="source-1">
                                        <div className="PI">PI</div>
                                        <div className="PI_unit">(%)</div>

                                    </div>
                                    <div className="source-2">{props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2_PERFUSION_INDEX]?.value
                                        ? props.vitalData_SPO2[MONITOR_PARAMETER.SPO2_PERFUSION_INDEX].value.toFixed(2)
                                        : "-"}
                                    </div>




                                </div>




                            </div>
                            <div className="middle">

                                <div className="value">
                                    {
                                        
                                        props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2]?.value ?? "-"

                                    }
                                    
                                </div>




                            </div>
                            <div className="right">

                                <div className="limits">
                                    <span className="high">{props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2]?.alarm_limit[1] ?? "-"}</span>
                                    <span className="low">{props.vitalData_SPO2?.[MONITOR_PARAMETER.SPO2]?.alarm_limit[0] ?? "-"}</span>
                                </div>


                            </div>



                        </div>


                    </div>

                </div>
                <div className="footer-wrap">

                    <div className="temp">

                        <div className="left">

                            <div className="temp-heading">

                                <div className="temp-name">TEMP</div>
                                <div className="temp-unit">(C)</div>


                            </div>

                            <div className="temp-values">

                                <div className="temp-value-1"> {props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_1]?.alarm_limit[1]
                                    ? props.vitalData_TEMP[MONITOR_PARAMETER.TEMPERATURE_1].alarm_limit[1].toFixed(1)
                                    : "-"}</div>
                                <div className="temp-value-2">{props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_1]?.alarm_limit[0]
                                    ? props.vitalData_TEMP[MONITOR_PARAMETER.TEMPERATURE_1].alarm_limit[0].toFixed(1)
                                    : "-"}</div>


                            </div>


                        </div>
                        <div className="middle">
                            <div className="T1">
                                <div className="T1-name">T1</div>
                                <div className="T1-value">


                                    {props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_1]?.value
                                        ? props.vitalData_TEMP[MONITOR_PARAMETER.TEMPERATURE_1].value.toFixed(1)
                                        : "-"}



                                </div>

                            </div>
                            <div className="TD">
                                <div className="TD-name">TD</div>
                                <div className="TD-value">(
                                    {
                                        (props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_DIFF]?.value
                                            ? props.vitalData_TEMP[MONITOR_PARAMETER.TEMPERATURE_DIFF].value.toFixed(1)
                                            : "-")
                                    }

                                    )</div>

                            </div>



                        </div>
                        <div className="right">

                            <div className="T2">
                                <div className="T2-name">T2</div>
                                <div className="T2-value">
                                    {props.vitalData_TEMP?.[MONITOR_PARAMETER.TEMPERATURE_2]?.value
                                        ? props.vitalData_TEMP[MONITOR_PARAMETER.TEMPERATURE_2].value.toFixed(1)
                                        : "-"}
                                </div>

                            </div>




                        </div>


                    </div>
                    <div className="nibp">

                        <div className="left">

                            <div className="nibp-data">

                                <div className="nibp-heading">

                                    <div className="nibp-name">NIBP</div>
                                    <div className="nibp-unit">(mmHg)</div>


                                </div>

                                <div className="nibp-values">

                                    <div className="nibp-value-1">{props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_SYSTOLIC]?.alarm_limit[1] ?? "-"}</div>
                                    <div className="nibp-value-2">{props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_SYSTOLIC]?.alarm_limit[0] ?? "-"}</div>


                                </div>

                            </div>

                            {/* <div className="nibp-time">2 Hours ago</div> */}






                        </div>
                        <div className="right">

                            <div className="nibp-value-3">

                                {


                                    `${props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_SYSTOLIC]?.value ?? "-"}/${props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_DIASTOLIC]?.value ?? "-"}`
                                }
                            </div>
                            <div className="nibp-value-4">(
                                {/* 110.3 */}
                                {
                                    props.vitalData_NIBP?.[MONITOR_PARAMETER.NIBP_MEAN]?.value ?? "-"

                                }
                                )
                            </div>



                        </div>



                    </div>

                </div>
            </div>
        );
    } else {
        return (
            <div className='offline'>
                <img className='monitor-offline' src={monitorOfflineIcon} alt="Monitor Offline" />
                <h2 className='not-in-use-text'>Monitor is currently offline, possibly due to settings or poor internet connection; please check and ensure proper configuration for seamless monitoring.</h2>
            </div>
        )
    }
}
